import actions from './actions'

export default function ProposalTravelCostReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PROPOSALTRAVELCOST:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PROPOSALTRAVELCOST:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PROPOSALTRAVELCOST:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PROPOSALTRAVELCOST:
      return {
        ...state,
        editing: { proposalTravelCostID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.DELETE_PROPOSALTRAVELCOST_RECIEVED:
      return {
        ...state,
        editing: { proposalTravelCostID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
